export const Common = {
	'Loading...': 'Cargando...',
	'We are saving your information...': 'Estamos guardando tu información...',
	'Current session is expired':
		'Tu sesión ha caducado. Por favor, ingresa nuevamente.',
	'Your session will expire in {{time}} min. Renew it to keep going.':
		'Tu sesión expirará en {{time}} min. Renuévala para no perder tu avance.',
	'Renew session': 'Renovar sesión',
	'Renewing...': 'Renovando...',
	'We could not renew your session. Please save and sign in again.':
		'No pudimos renovar tu sesión. Guarda tu avance e ingresa nuevamente.',
	Dismiss: 'Descartar',
	Maintenance: 'Mantención',
	'We are under maintenance. Please try again later.':
		'Estamos en mantención. Por favor, vuelve más tarde.',
	'No internet connection': 'Sin conexión a internet',
	'Check your connection and try again.':
		'Revisa tu conexión e intenta nuevamente.',
	'Retry now': 'Reintentar ahora',
	'Retrying automatically in {{seconds}}s':
		'Reintentando automáticamente en {{seconds}}s',
	Courses: 'Cursos',
	Certificates: 'Certificados',
	'Frequent questions': 'Preguntas frecuentes',
	'My profile': 'Mi perfil',
	Logout: 'Cerrar sesión',
	'My courses': 'Mis cursos',
	'Start Course': 'Comenzar curso',
	'Continue Course': 'Continuar curso',
	'Download certificate': 'Descargar certificado',
	'Downloading...': 'Descargando...',
	'My certificates': 'Mis certificados',
	Details: 'Detalles',
	Names: 'Nombres',
	Lastname: 'Apellidos',
	Email: 'Correo electronico',
	'Save changes': 'Guardar cambios',
	'Saving...': 'Guardando...',
	'You do not have any certificate yet':
		'Aún no tienes ningún certificado, ¡sigue estudiando!',
	Back: 'Atras',
	Next: 'Siguiente',
	'Skip recommendations': 'Saltar recomendaciones',
	// Step 1
	'Previous recommendations to validate your identity':
		'Recomendaciones previas para validar tu identidad',
	'To complete this process we need:':
		'Para completar este proceso necesitamos:',
	'Have your identity card handy': 'Ten a mano tu cédula de identidad',
	'Find a place with good illumination':
		'Encuentra un lugar con buena iluminación',
	'The following steps are intended to facilitate registration and ensure that the delivery of your courses is transparent and of quality.':
		'Los siguientes pasos están destinados a facilitar el registro y asegurar que la entrega de sus cursos sea transparente y de calidad.',
	'We assure you that the photos you give us will be':
		'Te aseguramos que las fotos que nos des serán',
	'completely confidential.': 'completamente confidencial.',
	'For more information on the use of data and photos, you can review the privacy policy.':
		'Para más información sobre el uso de datos y fotos, puede revisar la política de privacidad.',
	'Allows Webcam access': 'Permite el acceso a la cámara web',
	'Your browser could ask you to enable your webcam. If you see a message like this please click on "Allow"':
		'Su navegador podría pedirle que habilite su cámara web. Si ve un mensaje como este, haga clic en "Permitir"',
	'How to take a good photo of your DNI?':
		'¿Cómo hacer una buena foto de tu DNI?',
	'Align the corners just in the guideline intersection':
		'Alinear las esquinas justo en la intersección de la guía',
	'It is important that your identity card is not bent or uneven. If it is easier for you, affirm it with both hands.':
		'Es importante que su documento de identidad no esté doblado o desnivelado. Si te resulta más fácil, acéptalo con ambas manos.',
	'Make sure that the computer screen reflects as little as possible on your ID. If you can lower the brightness of the screen (look for the key with the sun).':
		'Asegúrese de que la pantalla de la computadora refleje lo menos posible en su identificación. Si puedes bajar el brillo de la pantalla (busca la tecla con el sol).',
	'Avoid those common mistakes': 'Evita esos errores comunes',
	'How to take a good photo of your face?':
		'¿Cómo tomar una buena foto de tu cara?',
	'Position your face right at the intersection of the guide lines':
		'Coloca tu cara justo en la intersección de las líneas guía',
	'Focus your full face and looking straight ahead.':
		'Enfoca tu cara completa y mira al frente.',
	'Make sure your facial features stand out.':
		'Asegúrate de que tus rasgos faciales se destaquen',
	'Remember that you should take in a place with good lighting.':
		'Recuerda que debes tomar en un lugar con buena iluminación.',
	'How to get better photos?': '¿Cómo obtener mejores fotos?',
	'Avoid those mistakes': 'Evitar esos errores',
	'A lot of light': 'Mucha luz',
	'A lot of shadow or backlight': 'Mucha sombra o luz de fondo',
	'Remember that you can also complete the registration from your cell phone, you will have better quality photos.':
		'Recuerda que también puedes completar el registro desde tu celular, tendrás fotos de mejor calidad.',
	'Done!': '¡Hecho!',
	'You can now start taking your photos and validate your identity.':
		'Ahora puede comenzar a tomar sus fotos y validar su identidad.',
	'Open PDF': 'Abrir PDF',
	'You do not have courses yet': 'Aun no tienes cursos',
	'Load courses': 'Actualizar Carga Académica',
	'Show more': 'Mostrar más',
	'Show less': 'Mostrar menos',
	'RUT or Email is required': 'RUT o Email es requerido',
	'Invalid RUT or Email': 'RUT o Email inválido',
	'My finished courses': 'Mis cursos finalizados',
	'Show finished courses': 'Mostrar cursos finalizados',
	Completed: 'Completado',
	'Quiz approved': 'Aprobada',
	'Quiz failed': 'Reprobada',
	'Certificate expires on': 'Certificado expira el',
	'The course is not available, it is not enabled, or you have to complete a previous course':
		'El curso no está disponible, no está habilitado o tiene que completar un curso anterior',
	Unavailable: 'No habilitado',
	Available: 'Disponible',
	'Course failed': 'Curso reprobado',
	'Days remaining': 'Días restantes',
	'The course ends today': 'El curso termina hoy',
	'Course closed': 'Curso cerrado',
	'Course approved': 'Curso aprobado',
	'Certificate expired': 'Certificado expirado',
	'Practical course': 'Curso práctico',
	'The practical course is not available right now. Please try again later.':
		'El curso práctico no está disponible en este momento. Por favor, intente nuevamente más tarde.',
	'Course not available': 'Curso no disponible',
	'The certificate cannot be downloaded':
		'No se puede descargar el certificado',
	'Course not finished': 'Curso no terminado',
	'The course has not been completed. Please complete the course to continue.':
		'El curso no ha sido completado. Por favor, complete el curso para continuar.',
	'Student disabled': 'Alumno deshabilitado',
	'The student cannot take the course right now. Please try again later.':
		'El alumno no puede realizar el curso en este momento. Por favor, intente nuevamente más tarde.',
	'You can view the material by': 'Puedes visualizar el material haciendo',
	'clicking here.': 'click aquí.',
	'Error 404, the route does not exist': 'Error 404, la ruta no existe',
	'Error 500, something went wrong': 'Error 500, algo salió mal',
	'You can always': 'Siempre puedes',
	'go back home': 'volver a inicio',
	'Contact support to get help if you keep seeing this error.':
		'Contacta a soporte para recibir ayuda en caso de que sigas viendo este error.',
	// Misc UI
	'Abrir clase en vivo': 'Abrir clase en vivo',
	Accept: 'Aceptar',
	'Close modal': 'Cerrar ventana',
	'Course closed on': 'Curso cerrado el',
	'Updating...': 'Actualizando...',
	'Step 1': 'Paso 1',
	'Step 2': 'Paso 2',
	'Step 3': 'Paso 3',
	'Step 4': 'Paso 4',
	'Step 5': 'Paso 5',
	'Step 6': 'Paso 6',
	'Carnet DNI': 'Carnet DNI',
	'Lamp Icon': 'Icono de lámpara',
	'Lock Icon': 'Icono de candado',
	'Watch the full video to continue.': 'Mira el video completo para continuar.',
	'The player could not be loaded. Disable your ad blocker and reload the page to continue.':
		'No se pudo cargar el reproductor. Desactiva tu bloqueador de anuncios y recarga la página para continuar.',
	'The video could not be loaded. Please reload the page.':
		'No se pudo cargar el video. Por favor, recarga la página.',
	'Your progress could not be saved': 'No se pudo guardar tu avance',
	'We could not mark this video as completed. Please try again.':
		'No pudimos marcar este video como completado. Inténtalo nuevamente.',
	'Try again': 'Reintentar',
};
